import { excelWorkbook, Grid, GridRow } from '@inavista/components/grid';
import { getCurrentDate } from 'projects/service/src/app/shared/utils/date-functions';

// The Excel file the Syncfusion grids gave, "<fileName>(<date>).xlsx": the visible data columns as the grid shows
// them (grid.excelSheet: labels, date formats; no checkbox or action column). `rows` defaults to the rows shown.
// For any inavista-grid page that keeps its old file name (use this, not a new copy).
export async function exportInavistaGrid(grid: Grid, fileName: string, rows?: readonly GridRow[], sheetName = fileName) {
  const sheet = grid.excelSheet(rows ?? grid.visibleRows());
  const blob = await excelWorkbook(sheet.rows, sheet.columns, { sheetName: sheetName.slice(0, 31) });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `${fileName}(${getCurrentDate()}).xlsx`;
  link.click();
  setTimeout(() => URL.revokeObjectURL(link.href), 1000);
}
